import { baseService } from "service/base";

class UserService {
  adminEdit(serviceArgs) {
    const { hasZeusAccess, id } = serviceArgs;

    return baseService.put(`/api/admin/user/${id}`, {
      has_zeus_access: hasZeusAccess,
    });
  }

  login(email, password) {
    return baseService.post("/api/auth", {
      email,
      password,
    });
  }

  loadCurrentUser() {
    return baseService.get("/api/user");
  }

  load() {
    return baseService.get("/api/users");
  }

  edit(userId, role, networkIds) {
    return baseService.put(`/api/user/${userId}`, {
      role,
      networkIds,
    });
  }

  invite(name, email, role, networkIds) {
    return baseService.post("/api/user/invite", {
      name,
      role,
      email,
      networkIds,
    });
  }

  inviteDetails(invitationId) {
    return baseService.get(`/api/user/invite/${invitationId}`);
  }

  register(invitationId, name, p1, p2) {
    return baseService.post("/api/user", {
      invitationId: invitationId,
      name,
      p1,
      p2,
    });
  }

  changePassword(p1, p2) {
    return baseService.put("/api/user", {
      p1,
      p2,
    });
  }

  forgotPassword(email) {
    return baseService.post("/api/user/forgot-password", {
      email,
    });
  }

  resetPassword(token, p1, p2) {
    return baseService.post("/api/user/reset-password", {
      token,
      p1,
      p2,
    });
  }
}

const userService = new UserService();

export { userService, UserService };
